import React, { useEffect, useState } from 'react';

import './styles.scss';
import Logo from '../../assets/logo.png';
import Card from '../../components/Card/Card';
import { getDrugstores } from '../../services/farmacias';
import ReactLoading from 'react-loading';


function Main() {

  const [farmacias, setFarmacias ] = useState('');

  useEffect(() => {
    getFarmacias()  
  },[]) 

  const getFarmacias = async () => { 
    const response = await getDrugstores();
    setFarmacias(response)
  }

  const getTodayStores = () => {
    const today = new Date();
    const stores = farmacias.filter(store => {
      const storeDate = new Date(store.horario.inicio);
      return storeDate.getDate() === today.getDate() && storeDate.getMonth() === today.getMonth();
    })

    return stores;
  }

   const otherStores = () => {
     const todayStores = getTodayStores();
     let otherStores = farmacias.filter(store => !todayStores.includes(store))

      const today = new Date();
      otherStores = otherStores.filter(store => {
        const storeDate = new Date(store.horario.inicio);
        return storeDate.getDate() >= today.getDate() && storeDate.getMonth() === today.getMonth();
      })

     return otherStores;
  }

  return(
    <>
      { farmacias ? (
        <div className="main">
        <header className='main_header'>
          <img src={Logo} alt="Logo" />
        </header>
        <div className='open_today' >
          <h1>Farmácias abertas hoje</h1>
            <div className='cards'>
            { getTodayStores()?.map((item) => (
             <Card data={item} />
          ))}
            </div>
        </div>
        <div className='next_week'>
          <h1>Próximas Abertas</h1>
          <div className='cards'>
            {  otherStores()?.map((item) => (
             <Card data={item} />
          )) }
            </div>
        </div>
      
      </div>
      ) : (
      <div className='loading'>
        <ReactLoading type={'spinningBubbles'} color={'#ffffff'} height={100} width={100} />
        <h1>Aguarde enquanto procuramos as farmácias</h1>
      </div> )}
    </>
    
  )
}

export default Main;